import { render, staticRenderFns } from "./ElectronicContractOrder.vue?vue&type=template&id=48ff2c6e&scoped=true"
import script from "./ElectronicContractOrder.vue?vue&type=script&lang=js"
export * from "./ElectronicContractOrder.vue?vue&type=script&lang=js"
import style0 from "./ElectronicContractOrder.vue?vue&type=style&index=0&id=48ff2c6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff2c6e",
  null
  
)

export default component.exports